import AttendanceRateList from "@/controllers/attendance_rate/attendance_rate_list.js";

export default {
  extends: AttendanceRateList,
};
